import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Loader from '../utils/loader'

import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'
import { Dialog, Button, Paper, FormControl, Grid, InputBase, InputAdornment, Typography } from '@material-ui/core'
import Search from '@material-ui/icons/Search'
import '../styles/home-page.css'
import calendar from '../images/Icons/calendar.png'

import Summary from './Summary'

import { getExamAction } from '../actions/exams'
import { getPdfAction } from '../actions/exams'
import { resetErrors } from '../actions/global'

const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      margin: theme.spacing(),
    },
    cssLabel: {
      '&$cssFocused': {
        border: 'solid 1px #0b428e',
        boxShadow: '0px 0px 0px 1px #0b428e'
      },
    },
    cssFocused: {},
    cssUnderline: {
      '&:after': {
        borderBottomColor: 'purple',
      },
    },
    cssOutlinedInput: {
      '&$cssFocused $notchedOutline': {
        borderColor: 'purple',
      },
    },
    notchedOutline: {},
    bootstrapRoot: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    bootstrapInput: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: 'white',
      border: '1px solid #ced4da',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
    bootstrapFormLabel: {
      fontSize: 18,
    },
  });

class Home extends Component {
    constructor(props){
        super(props);

        this.state = {
            examList: {},
            currentExam: {},
            currentPage: 1,
            search: '',
            isPDFLoading: {},
            isPatientSelected: false    
        };
    }

    componentDidMount() {        
        let query = {
            offset: 0
        }
        this.props.getExamAction(query);
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, () => {
            this.onSearch();
        });
    };

    onSearch = () => {

        this.setState({
            currentPage: 1
        }, () => {
            let query = {            
                q: this.state.search,
                page: parseInt(1),
            }
            this.props.getExamAction(query);
            window.scrollTo(0,0);
        })
    }

    onPageChange = (event) => {
        this.setState({
            currentPage: parseInt(event.currentTarget.id, 10)
        }, () => {
            let query ={
                q: this.state.search,
                page: this.state.currentPage
            }
            this.props.getExamAction(query);
            window.scrollTo(0,0);
        })        
    }

    onNextPage = () => {

        const nextPage = parseInt(this.state.currentPage) + 1
        this.setState({
            currentPage: nextPage
        }, () => {
            let query ={
                q: this.state.search,
                page: this.state.currentPage
            }
            this.props.getExamAction(query);
            window.scrollTo(0,0);
        })        
    }

    onPreviousPage = () => {

        const prevPage = parseInt(this.state.currentPage) - 1
        this.setState({
            currentPage: prevPage
        }, () => {
            let query ={
                q: this.state.search,
                page: this.state.currentPage
            }
            this.props.getExamAction(query);
            window.scrollTo(0,0);
        })        
    }

    onFirstPage = () => {

        this.setState({
            currentPage: 1
        }, () => {
            let query ={
                q: this.state.search,
                page: this.state.currentPage
            }
            this.props.getExamAction(query);
            window.scrollTo(0,0);
        })        
    }

    onLastPage = () => {

        this.setState({
            currentPage: this.props.examList.n_pages
        }, () => {
            let query ={
                q: this.state.search,
                page: parseInt(this.state.currentPage, 10)
            }
            this.props.getExamAction(query);
            window.scrollTo(0,0);
        })        
    }

    showSummary = (event) => {
        let exam = this.props.examList.results.find(currentExam => currentExam.exam_id.toString() === event.currentTarget.id )
        this.setState({currentExam : exam})
        this.setState(state => ({ isPatientSelected: !state.isPatientSelected}))
    }

    downloadPdf = () => {
        this.setState({
            isLoading: true
        }, () => {
            this.props.getPdfAction(this.state.currentExam.report_id);
        })
    }

    handleSummaryClose = () => {
        this.setState({ isPatientSelected: false })
    }

    handleSnackbarClose = () => {
        this.props.resetErrors();
    };

    setScreenPages() {
        let pagination = [];
        for(let i=1; i <= this.props.examList.n_pages; i++){
            pagination[i-1] = i;
        }

        if(this.state.currentPage === this.props.examList.n_pages){
            return (
                pagination.slice(this.state.currentPage-8, this.state.currentPage).map(item => (
                    <Button
                        id={item}
                        variant='contained'
                        className='pag-button'
                        disabled={(item === this.state.currentPage)}
                        onClick={this.onPageChange}>
                            {item}
                    </Button>
                ))
            )
        }
        else if(this.state.currentPage > 7){
            return(
                pagination.slice(this.state.currentPage-7, this.state.currentPage+1).map((item) => (
                    <Button
                        id={item}
                        variant='contained'
                        className='pag-button'
                        disabled={(item === this.state.currentPage)}
                        onClick={this.onPageChange}>
                            {item}
                    </Button>
                ))
            )
        }
        else {
            return (
                pagination.slice(0, 8).map((item) => (
                    <Button
                        id={item}
                        variant='contained'
                        className='pag-button'
                        disabled={(item === this.state.currentPage)}
                        onClick={this.onPageChange}>
                            {item}
                    </Button>
                ))
            )
        }
    }

    render(){
        const list = (this.props.examList.results) ? this.props.examList.results.slice() : [];
        const { classes } = this.props;

        return (
            <div style={{backgroundColor:'whitesmoke'}}>
                <Loader active={this.props.isLoading}/> 
                {this.state.isPatientSelected ?
                    <Dialog
                        fullWidth
                        maxWidth={'md'}
                        open={this.state.isPatientSelected}
                        onClose={this.handleSummaryClose}>
                    <Summary
                        handleSnackbarClose={this.handleSnackbarClose.bind(this)}
                        error={this.props.errors.status}
                        exam={this.state.currentExam} 
                        downloadPdf={this.downloadPdf.bind(this)}
                        />
                    </Dialog>
                :
                    null
                }
                <Grid container direction='row' className='home-bg' justify='center'>
                    <Grid item md={2}></Grid>
                    <Grid
                    md={8}
                    item 
                    container 
                    direction='column'
                    justify='space-evenly'
                    alignItems='center'>
                        <Grid item>
                            <FormControl variant="outlined">
                                <InputBase
                                    className='search-form'
                                    classes={{
                                        root: classes.cssLabel,
                                        focused: classes.cssFocused,
                                    }}
                                    id="search-input"
                                    name="search"
                                    onChange={this.handleChange}
                                    endAdornment={
                                    <InputAdornment
                                        className='search-icon'>
                                        <Search/>
                                    </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            container
                            direction='column'
                            justify='center'
                            alignItems='center'>
                            <Grid 
                                container
                                className='exam-header'
                                direction='row'
                                alignItems='center'
                                justify='flex-start'>
                                <Grid item xs={false} sm={1} className='date'>
                                    <Typography align='center'>
                                        <img src={calendar} alt='Data do exame' style={{height: '24px', width: '24px'}}/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={false} sm={2}>
                                <p align='center'>
                                        ESPÉCIE
                                    </p>
                                </Grid>
                                <Grid item xs={false} sm={2}>
                                    <p align='center'>
                                        NOME
                                    </p>
                                </Grid>
                                <Grid item xs={false} sm={3}>
                                    <p align='center'>
                                        RAÇA
                                    </p>
                                </Grid>
                                <Grid item xs={false} sm={3}>
                                    <p align='center'>
                                        NOME ACOMPANHANTE
                                    </p>
                                </Grid>
                            </Grid>     
                        </Grid>                    
                        <Grid
                            item
                            container
                            direction='column'
                            justify='center'
                            alignItems='center'>
                            {list.slice(0, 20).map((item) => {
                                return (
                                    <div id={item.exam_id} key={item.exam_id} onClick={this.showSummary} style={{width: '100%'}}>
                                        <Button fullWidth>
                                            <Paper className='exam-paper'>
                                                <Grid
                                                container
                                                alignItems='center'
                                                direction='row'
                                                justify='flex-start'>
                                                    <Grid item container justify='center' sm={1} style={{fontWeight: 600}}>
                                                        <p align='center'>
                                                            {moment(item.created).format('DD')}
                                                            <br/>
                                                            {moment(item.created).format('MMM')}
                                                        </p>
                                                    </Grid>
                                                    <Grid item container justify='center' sm={2}>
                                                        <img className='animal-icon' src={item.specie.icon} alt={item.specie.name}/>
                                                    </Grid>
                                                    <Grid item container justify='center' sm={2} style={{fontWeight: 600}}>
                                                        <p align='center'>
                                                            {item.animal}
                                                        </p>
                                                    </Grid>
                                                    <Grid item container justify='center' sm={3}>
                                                        <p align='center'>
                                                            {item.breed.name}
                                                        </p>
                                                    </Grid>
                                                    <Grid item container justify='center' sm={3}>
                                                        <p align='center'>
                                                            {item.animal_owner !== ""? item.animal_owner : "NÃO INFORMADO"}
                                                        </p>
                                                    </Grid>
                                                </Grid>                                   
                                            </Paper>
                                        </Button>
                                    </div>
                            )})}
                        </Grid>
                            <Grid>
                                {(this.props.examList.length === 0 || this.props.examList.n_pages === 1) ?
                                    null
                                :
                                    <Grid container direction='row'>
                                        <Button
                                            variant='contained'
                                            className='pag-button'
                                            disabled={this.state.currentPage === 1}
                                            onClick={this.onFirstPage}>
                                            &#60;&#60;
                                        </Button>
                                        <Button
                                            variant='contained'
                                            className='pag-button'
                                            disabled={this.state.currentPage === 1}
                                            onClick={this.onPreviousPage}>
                                            &#60;
                                        </Button>
                                        
                                        {this.setScreenPages()}

                                        <Button
                                            variant='contained'
                                            className='pag-button'
                                            disabled={this.state.currentPage === this.props.examList.n_pages}
                                            onClick={this.onNextPage}>
                                            &#62;
                                        </Button>
                                        <Button
                                            variant='contained'
                                            className='pag-button'
                                            disabled={this.state.currentPage === this.props.examList.n_pages}
                                            onClick={this.onLastPage}>
                                            &#62;&#62;
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    <Grid item md={2}></Grid>
                </Grid>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        examList: state.exam.examList,
        isLoading: state.exam.isLoading,
        errors: state.exam.errors,
    }   
}

function mapDispatchToProps(dispatch) {
    return {
        getExamAction: (query) => {
            dispatch(getExamAction(query))
        },
        getPdfAction: (report_id) => {
            dispatch(getPdfAction(report_id))
        },
        resetErrors: () => {
            dispatch(resetErrors())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home)));
